"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fas(name) {
    return { name: name, style: "fas" };
}
function fab(name) {
    return { name: name, style: "fab" };
}
exports.DefaultOptions = {
    prefix: "fa-",
    icons: {
        browser: {
            androidBrowser: fab("android"),
            internetExplorer: fab("internet-explorer"),
            operaCoast: fab("opera"),
            blackBerry: fab("blackberry"),
            chrome: fab("chrome"),
            chromium: fab("chrome"),
            edge: fab("edge"),
            firefox: fab("firefox"),
            googlebot: fab("google"),
            opera: fab("opera"),
            phantomJS: fas("ghost"),
            safari: fab("safari"),
        },
        os: {
            android: fab("android"),
            blackBerry: fab("blackberry"),
            iOS: fab("apple"),
            linux: fab("linux"),
            macOS: fab("apple"),
            playStation4: fab("playstation"),
            windows: fab("windows"),
        },
        platform: {
            desktop: fas("desktop"),
            mobile: fas("mobile-alt"),
            tablet: fas("tablet-alt"),
            tv: fas("tv"),
        }
    },
    default: {
        browser: fas("question"),
        os: fas("question"),
        platform: fas("question"),
    }
};
//# sourceMappingURL=default-options.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fontawesome-user-agent/lib/cjs/default-options.js
// module id = D+Q1
// module chunks = 0 105 118